export enum SiteTourAnchors {
  NavMenu = 'global-nav.menu',
  NavPerson = 'global-nav.person',
  ProfileDetails = 'profile-details.view',
  ProfileActivities = 'profile-activities.view',
  PreferencesFollow = 'preferences.follow-artist',
  AsyncPlaceholder = 'async-placeholder-anchor',
}
